/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  alpha: {
    type: Number,
    "default": 1
  },
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  height: {
    type: Number
  },
  isRepeat: {
    type: Boolean,
    "default": true
  },
  lineSpace: {
    type: Number,
    "default": 16
  },
  movable: Boolean,
  moveInterval: {
    type: Number,
    "default": 3e3
  },
  offset: {
    type: Array
  },
  removable: {
    type: Boolean,
    "default": true
  },
  rotate: {
    type: Number,
    "default": -22
  },
  watermarkContent: {
    type: [Object, Array]
  },
  width: {
    type: Number
  },
  x: {
    type: Number
  },
  y: {
    type: Number
  },
  zIndex: {
    type: Number
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
